<template>
  <el-form
    status-icon
    :model="ruleForm"
    :rules="rules"
    label-position="top"
    ref="ruleForm"
    v-loading="loading"
    label-width="120px"
    class="carpo-form demo-ruleForm"
  >
    <PriceInput
      :loading="loading"
      label="DEPRECIATION_COST"
      prop="hourly_depreciation_cost"
      :model="ruleForm.hourly_depreciation_cost"
      @update="ruleForm.hourly_depreciation_cost = $event"
      :disabled="car.disabled"
    />

    <PriceInput
      :loading="loading"
      label="OTHER_COSTS"
      prop="other_cost_per_kilometer"
      :model="ruleForm.other_cost_per_kilometer"
      @update="ruleForm.other_cost_per_kilometer = $event"
      :disabled="car.disabled"
    />

    <FormConfirmation
      :loading="submitLoading"
      v-if="!car.disabled"
      @resetForm="resetForm('ruleForm')"
      @submitForm="submitForm('ruleForm')"
    />
  </el-form>
</template>
<script>
import { resetForm } from '@/mixins/resetForm'
import { editCost, getCost, addCost } from '@/api/cars'
import FormConfirmation from '@/components/elements/formConfirmation.vue'
import PriceInput from '@/components/elements/priceInput.vue'
import { reverseCurrency } from '@/mixins/reverseCurrency'
import { currency } from '@/mixins/currency'
export default {
  mixins: [resetForm, reverseCurrency, currency],
  props: {
    car: {
      type: Object,
      required: false,
    },
  },
  components: {
    FormConfirmation,
    PriceInput,
  },
  data() {
    return {
      value: [],
      submitLoading: false,
      test: null,
      loading: true,
      ruleForm: {
        disabled: false,
        hourly_depreciation_cost: '',
        other_cost_per_kilometer: '',
      },
      get_car: null,

      rules: {},
    }
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const actionPayload = {
            id: this.$route.params.id,
            company_vehicle: this.$route.params.id,
            other_cost_per_kilometer:
              this.ruleForm.other_cost_per_kilometer != ''
                ? this.reverseCurrency(this.ruleForm.other_cost_per_kilometer)
                : null,
            hourly_depreciation_cost:
              this.ruleForm.hourly_depreciation_cost != ''
                ? this.reverseCurrency(this.ruleForm.hourly_depreciation_cost)
                : null,
          }

          this.submitLoading = true
          var dispatchFunc = this.get_car == null ? addCost : editCost

          dispatchFunc.api(actionPayload).then((res) => {
            this.submitLoading = false
            if (res) {
              this.get_car = res
              this.$notify.success({
                title: this.$t('COST_INFO') + ' ' + this.$t('SUCCESSFULLY_'),
                duration: 5000,
                customClass: 'succ_msg',
              })
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t('COST_INFO'),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
  },
  mounted() {
    this.ruleForm = this.car
    getCost.api(this.ruleForm.carId).then((res) => {
      this.loading = false
      if (res) {
        res = {
          ...res,
          other_cost_per_kilometer: this.currency(res.other_cost_per_kilometer),
          hourly_depreciation_cost: this.currency(res.hourly_depreciation_cost),
        }
        this.ruleForm = res
        this.get_car = res
      }
    })
  },
}
</script>
